module.exports = require("leaflet/dist/leaflet.css");